export const storeBookingAttachments = (state, attachments) => {
  state.attachments = { ...attachments };
};
